import React from 'react'

const LockSvg = ({className}: {className?: string}) => {
  return (
    <svg className={className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="lock">
      <path id="Vector" fillRule="evenodd" clipRule="evenodd" d="M12 2.75C10.8728 2.75 9.79181 3.19777 8.99478 3.9948C8.19775 4.79183 7.74998 5.87283 7.74998 7V10.25H16.25V7C16.25 5.87283 15.8022 4.79183 15.0052 3.9948C14.2082 3.19777 13.1272 2.75 12 2.75ZM17.75 10.25V7C17.75 5.47501 17.1442 4.01247 16.0658 2.93414C14.9875 1.8558 13.525 1.25 12 1.25C10.475 1.25 9.01245 1.8558 7.93412 2.93414C6.85579 4.01247 6.24998 5.47501 6.24998 7V10.25H5C3.48122 10.25 2.25 11.4812 2.25 13V20C2.25 21.5188 3.48122 22.75 5 22.75H19C20.5188 22.75 21.75 21.5188 21.75 20V13C21.75 11.4812 20.5188 10.25 19 10.25H17.75ZM5 11.75C4.30964 11.75 3.75 12.3096 3.75 13V20C3.75 20.6904 4.30964 21.25 5 21.25H19C19.6904 21.25 20.25 20.6904 20.25 20V13C20.25 12.3096 19.6904 11.75 19 11.75H5Z" fill="#9D9D9D"/>
      </g>
    </svg>
  )
}

export default LockSvg
